import { render, staticRenderFns } from "./campanya.vue?vue&type=template&id=1391171e"
import script from "./campanya.vue?vue&type=script&lang=js"
export * from "./campanya.vue?vue&type=script&lang=js"
import style0 from "./campanya.vue?vue&type=style&index=0&id=1391171e&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports